<template>
  <div class="container-fluid mt-5">
    <div class="row">
      <div class="col-xl-12 stock-movement-xl-1">
        <card>
          <div slot="header" class="row align-items-center">
            <div class="col-8">
              <h3 class="mb-0">
                {{ $t("STOCK_MOVEMENTS.EDIT_STOCK_MOVEMENT") }}
              </h3>
            </div>
            <div class="col-4 text-right">
              <base-button
                @click="goBack"
                type="button"
                class="btn btn-sm btn-primary"
              >
                {{ $t("COMMON.RETURN_TO_LIST") }}
              </base-button>
            </div>
          </div>
          <div class="card-body">
            <stock-movement-form
              :loading="loading"
              :stockMovementData="stockMovement"
              :formErrors="formErrors"
              @stockMovementSubmitted="handleSubmit"
              @formChanged="() => (alertLeave = true)"
            />
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import StockMovementForm from "./partials/StockMovementForm.vue";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultStockMovement from "./defaultStockMovement";

export default {
  layout: "DashboardLayout",

  components: { StockMovementForm },

  mixins: [alertLeave],

  data() {
    return {
      stockMovement: cloneDeep(defaultStockMovement),
      formErrors: null,
      loading: false,
    };
  },

  created() {
    this.get();
  },

  methods: {
    async get() {
      this.loading = true;
      try {
        const id = this.$route.params.id;
        await this.$store.dispatch("stockMovements/get", id);
        this.stockMovement =
          this.$store.getters["stockMovements/stockMovement"];
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    goBack() {
      this.$router.push({ name: "List StockMovements" });
    },

    viewStockMovement() {
      this.alertLeave = false;
      this.$router.push({
        name: "View StockMovement",
        params: { id: this.stockMovement.id },
      });
    },

    async handleSubmit(stockMovement) {
      this.loading = true;
      const stockMovementData = cloneDeep(stockMovement);
      try {
        await this.$store.dispatch("stockMovements/update", stockMovementData);
        this.$notify({
          type: "success",
          message: this.$t("STOCK_MOVEMENTS.STOCK_MOVEMENT_UPDATED"),
        });
        this.viewStockMovement();
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
